export const TokenService = {
  getLocalAccessToken : () => {
    const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));
    return accessToken;
  },

  getLocalRefreshToken : () => {
    const refreshToken = JSON.parse(sessionStorage.getItem("refreshToken"));
    return refreshToken;
  },

  setUser : (user) => {
    sessionStorage.setItem("user", JSON.stringify(user));
    sessionStorage.setItem("accessToken", JSON.stringify(user.token));
    sessionStorage.setItem("refreshToken", JSON.stringify(user.refreshToken));
  },

  removeUser : () => {
    sessionStorage.setItem("menu", "{}");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
  }
}
